import { defineProperty as _defineProperty } from '../../../../_virtual/_rollupPluginBabelHelpers.js';
import React from 'react';
import { usePathContext } from '../../../../context/PathContext.js';
import classNames from 'classnames';
import PlainText from '../../../../components/PlainText/index.js';
import styles from './styles.css.js';

var InputLabel = function InputLabel(_ref) {
  var question = _ref.question;
  var pathContext = usePathContext();
  var inputLabel = question.commonFields.inputLabel;

  if (inputLabel) {
    return React.createElement("div", {
      className: classNames(styles.container, _defineProperty({}, styles.placementModal, pathContext.pathPlacement === 'modal'))
    }, inputLabel && React.createElement(PlainText, {
      plainTextEntry: inputLabel,
      className: styles.label
    }));
  }

  return null;
};

export default InputLabel;
//# sourceMappingURL=index.js.map
